<template>
  <div>
    <div v-if="showPopup" class="overlay">
      <div class="popup">
        <p><b>Är du kvar?</b><br>Du kommer att loggas ut snart, om du inte rör vid skärmen.</p>
        <!-- <button @click="resetTimers" class="btn btn-primary">Ja, jag är här</button>-->
      </div>
    </div>
  </div>
</template>

<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup {
  background: white;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(0,0,0,0.3);
  text-align: center;
}

.popup p {
  margin-bottom: 15px;
  font-size: 1.1em;
}
</style>
<script>
export default {
  name: 'InactivityMonitor',
  data: () => ({
    inactivityTimer: null,
    popupTimer: null,
    showPopup: false,
    inactivityTimeout: 30 * 60 * 1000, // 15 minutes
    popupTimeout: 5 * 60 * 1000 // 5 minutes
  }),
  
  mounted() {
    this.startTimers()
    window.addEventListener('mousemove', this.resetTimers)
    window.addEventListener('keypress', this.resetTimers)
    window.addEventListener('click', this.resetTimers)
  },

  beforeDestroy() {
    this.clearTimers()
    window.removeEventListener('mousemove', this.resetTimers)
    window.removeEventListener('keypress', this.resetTimers)
    window.removeEventListener('click', this.resetTimers)
  },

  methods: {
    startTimers() {
      this.inactivityTimer = setTimeout(() => {
        if (this.$router.currentRoute.path === '#' || this.$router.currentRoute.path === '/register') return
        this.showPopup = true
        this.startPopupTimer()
      }, this.inactivityTimeout)
    },

    startPopupTimer() {
      this.popupTimer = setTimeout(() => {
        this.$store.dispatch('logout');
        this.$router.push({ name: 'login'});
      }, this.popupTimeout)
    },

    clearTimers() {
      clearTimeout(this.inactivityTimer)
      clearTimeout(this.popupTimer)
    },

    resetTimers() {
      this.clearTimers()
      this.showPopup = false
      this.startTimers()
    }
  }
}
</script>